import './nav.scss';
import ReactGA from 'react-ga';
import { useSelector } from 'react-redux';

import React from 'react';
import { Layout } from 'antd';
import loadable from '@loadable/component';
import { IApplicationState } from '../../store';
import { languageList } from '../../helpers/lang';

const { Header } = Layout;

const Nav: React.FunctionComponent = () => {
    const logo = `/static/zerolatency-new.png`;
    const currentLocale = useSelector((state: IApplicationState) => state.intl.currentLocale);
    const globalWebsiteUrl = useSelector((state: IApplicationState) => state.appSettings.globalWebsiteUrl);

    const LanguageSwitcherComponent = loadable(() => import('../language-switcher/language-switcher'), {
        fallback: <React.Fragment />,
    });

    let trackers: string[] = ['zerolatency'];

    //ensure outbound links to the global website respect the users language choice (provided the global website supports it)
    const lang = languageList.find((lng) => lng.code === currentLocale || lng.momentLocale === currentLocale);

    const globalWebsiteLink = `${globalWebsiteUrl}/${lang?.globalWebsiteLangCode || 'en'}`;

    return (
        <Header className="nav-container">
            <div className="nav">
                <ReactGA.OutboundLink
                    eventLabel="Navigate to Main Site"
                    to={globalWebsiteLink}
                    target="_top"
                    title="Zero Latency Website"
                    trackerNames={trackers}
                    className="logo"
                >
                    <img src={logo} alt="Zero Latency Free Roam Virtual Reality" />
                </ReactGA.OutboundLink>
                <LanguageSwitcherComponent />
            </div>
        </Header>
    );
};

export default Nav;
